import React, { useState, useEffect } from "react";
import ClassNames from "classnames";
import * as s from "./s.module.scss";
import { animated, useTrail } from "react-spring";
import Portal from "../../Portal";
import LocalizedLink from "../../LocalizedLink";
import { faChevronDown, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import content from "../../../../content/global";
import { getStaticData } from "../../../helperFunctions";
import { useBodyClass } from "../../_customHooks";

const MobileNav = ({
  data,
  onGetInTouchClick,
  currentPath,
  locale,
  setModalIsOpen,
}) => {
  const tdcxCN = process.env.GATSBY_BUILD_SITE === "china";

  const [menuState, setMenuState] = useState("inactive");

  const toggleMenu = () => {
    switch (menuState) {
      case "inactive":
        setMenuState("active");
        break;
      case "active":
      case "subMenuActive":
        setMenuState("inactive");
        break;
      default:
        setMenuState("inactive");
        break;
    }
  };

  const config = { mass: 1, tension: 2000, friction: 100 };

  const transitions = useTrail(null, {
    config,
    opacity: menuState === "subMenuActive" || menuState === "active" ? 1 : 0,
    transformOverlay:
      menuState === "subMenuActive" || menuState === "active"
        ? "translate3d(0%, 0%, 0)"
        : "translate3d(0%, -100%, 0)",
    transform:
      menuState === "subMenuActive"
        ? "translate3d(-100%, 0%, 0)"
        : menuState === "active"
        ? "translate3d(0%, 0%, 0)"
        : "translate3d(0%, -100%, 0)",
    from: { transform: "translate3d(0%, -100%, 0)" },
  });

  useBodyClass(
    menuState === "active" || menuState === "subMenuActive",
    s.mobileNavOpen
  );

  return (
    <>
      <div>
        <button
          className={ClassNames(s.hamburger, s.hamburger3dxy, {
            [s.isActive]:
              menuState === "active" || menuState === "subMenuActive",
          })}
          type="button"
          onClick={toggleMenu}
          aria-label="important button"
        >
          <span className={s.hamburgerBox}>
            <span className={s.hamburgerInner} />
          </span>
        </button>
      </div>
      <Portal>
        <>
          {transitions.map(
            ({ transform, transformOverlay, opacity, ...props }, index) => (
              <div key={index}>
                <animated.div
                  style={{
                    ...props,
                    position: "fixed",
                    top: 56,
                    left: 0,
                    opacity: opacity.interpolate((x) => `${x}`),
                    transform: transformOverlay.interpolate((x) => `${x}`),
                  }}
                  className={s.mobileMenuOverlay}
                />
                <animated.div
                  style={{
                    ...props,
                    transform: transform.interpolate((x) => `${x}`),
                  }}
                  className={s.mobileMenuWrapper}
                >
                  <div className={s.headerMobileMenu}>
                    <Accordion allowZeroExpanded={true}>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton
                            className={ClassNames(s.headerMobileMenuHeading, {
                              [s.isActive]:
                                currentPath && currentPath.includes("services"),
                            })}
                          >
                            <LocalizedLink
                              to={getStaticData(content.services, locale).link}
                            >
                              {getStaticData(content.services, locale).title}
                            </LocalizedLink>
                            <div className={s.iconWrapper}>
                              <FontAwesomeIcon icon={faChevronDown} />
                            </div>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <ul className={s.headerMobileMenuLists}>
                            {getStaticData(
                              content.services_sub_menus,
                              locale
                            ).map((menu, i) => {
                              if (menu.subNav2) {
                                return (
                                  <Accordion allowZeroExpanded={true} key={i}>
                                    <AccordionItem>
                                      <AccordionItemHeading>
                                        <AccordionItemButton
                                          className={ClassNames(
                                            s.headerMobileMenuHeading2,
                                            {
                                              [s.isActive]:
                                                currentPath &&
                                                currentPath.includes(
                                                  "services"
                                                ),
                                            }
                                          )}
                                        >
                                          <LocalizedLink to={menu.link}>
                                            {menu.title}
                                          </LocalizedLink>
                                          <div className={s.iconWrapper}>
                                            <FontAwesomeIcon
                                              icon={faChevronDown}
                                            />
                                          </div>
                                        </AccordionItemButton>
                                      </AccordionItemHeading>
                                      <AccordionItemPanel>
                                        <ul
                                          className={s.headerMobileMenuLists2}
                                        >
                                          {getStaticData(
                                            content.ai_consulting_sub_menus,
                                            locale
                                          ).map((menu, i) => (
                                            <li
                                              className={
                                                s.headerMobileMenuListItem
                                              }
                                              key={i}
                                            >
                                              <LocalizedLink to={menu.link}>
                                                {menu.title}
                                              </LocalizedLink>
                                            </li>
                                          ))}
                                        </ul>
                                      </AccordionItemPanel>
                                    </AccordionItem>
                                  </Accordion>
                                );
                              } else {
                                return (
                                  <li
                                    className={s.headerMobileMenuListItem}
                                    key={i}
                                  >
                                    <LocalizedLink to={menu.link}>
                                      {menu.title}
                                    </LocalizedLink>
                                  </li>
                                );
                              }
                            })}
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>

                    <Accordion allowZeroExpanded={true}>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton
                            className={ClassNames(s.headerMobileMenuHeading, {
                              [s.isActive]:
                                currentPath &&
                                currentPath.includes("industries"),
                            })}
                          >
                            <LocalizedLink
                              to={
                                getStaticData(content.industries, locale).link
                              }
                            >
                              {getStaticData(content.industries, locale).title}
                            </LocalizedLink>
                            <div className={s.iconWrapper}>
                              <FontAwesomeIcon icon={faChevronDown} />
                            </div>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <ul className={s.headerMobileMenuLists}>
                            {getStaticData(
                              content.industries_sub_menus,
                              locale
                            ).map((menu, i) => (
                              <li
                                className={s.headerMobileMenuListItem}
                                key={i}
                              >
                                <LocalizedLink to={menu.link}>
                                  {menu.title}
                                </LocalizedLink>
                              </li>
                            ))}
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>

                    <Accordion allowZeroExpanded={true}>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton
                            className={ClassNames(s.headerMobileMenuHeading, {
                              [s.isActive]:
                                currentPath && currentPath.includes("about"),
                            })}
                          >
                            <LocalizedLink
                              to={getStaticData(content.about, locale).link}
                            >
                              {getStaticData(content.about, locale).title}
                            </LocalizedLink>
                            <div className={s.iconWrapper}>
                              <FontAwesomeIcon icon={faChevronDown} />
                            </div>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <ul className={s.headerMobileMenuLists}>
                            {getStaticData(content.about_sub_menus, locale).map(
                              (menu, i) => (
                                <li
                                  className={s.headerMobileMenuListItem}
                                  key={i}
                                >
                                  <LocalizedLink to={menu.link}>
                                    {menu.title}
                                  </LocalizedLink>
                                </li>
                              )
                            )}
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>

                    <Accordion allowZeroExpanded={true}>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton
                            className={ClassNames(s.headerMobileMenuHeading, {
                              [s.isActive]:
                                currentPath &&
                                currentPath.includes("media-center"),
                            })}
                          >
                            <LocalizedLink
                              to={getStaticData(content.media, locale).link}
                            >
                              {getStaticData(content.media, locale).title}
                            </LocalizedLink>
                            <div className={s.iconWrapper}>
                              <FontAwesomeIcon icon={faChevronDown} />
                            </div>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <ul className={s.headerMobileMenuLists}>
                            {getStaticData(content.media_sub_menus, locale).map(
                              (menu, i) => {
                                if (menu.subNav2) {
                                  return (
                                    <Accordion key={i} allowZeroExpanded={true}>
                                      <AccordionItem>
                                        <AccordionItemHeading>
                                          <AccordionItemButton
                                            className={ClassNames(
                                              s.headerMobileMenuHeading2,
                                              {
                                                [s.isActive]:
                                                  currentPath &&
                                                  currentPath.includes(
                                                    "insights"
                                                  ),
                                              }
                                            )}
                                          >
                                            <LocalizedLink to={menu.link}>
                                              {menu.title}
                                            </LocalizedLink>
                                            <div className={s.iconWrapper}>
                                              <FontAwesomeIcon
                                                icon={faChevronDown}
                                              />
                                            </div>
                                          </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                          <ul
                                            className={s.headerMobileMenuLists2}
                                          >
                                            {getStaticData(
                                              content.insights_sub_menus,
                                              locale
                                            ).map((menu, i) => (
                                              <li
                                                className={
                                                  s.headerMobileMenuListItem
                                                }
                                                key={i}
                                              >
                                                <LocalizedLink to={menu.link}>
                                                  {menu.title}
                                                </LocalizedLink>
                                              </li>
                                            ))}
                                          </ul>
                                        </AccordionItemPanel>
                                      </AccordionItem>
                                    </Accordion>
                                  );
                                } else {
                                  return (
                                    <li
                                      className={s.headerMobileMenuListItem}
                                      key={menu?.title}
                                    >
                                      <LocalizedLink to={menu.link}>
                                        {menu.title}
                                      </LocalizedLink>
                                    </li>
                                  );
                                }
                              }
                            )}
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>

                    <Accordion allowZeroExpanded={true}>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton
                            className={ClassNames(s.headerMobileMenuHeading, {
                              [s.isActive]:
                                currentPath && currentPath.includes("careers"),
                            })}
                          >
                            <LocalizedLink
                              to={getStaticData(content.careers, locale).link}
                            >
                              {getStaticData(content.careers, locale).title}
                            </LocalizedLink>
                            <div className={s.iconWrapper}>
                              <FontAwesomeIcon icon={faChevronDown} />
                            </div>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <ul className={s.headerMobileMenuLists}>
                            {getStaticData(
                              content.career_sub_menus,
                              locale
                            ).map((menu, i) => (
                              <li
                                className={s.headerMobileMenuListItem}
                                key={i}
                              >
                                <LocalizedLink to={menu.link}>
                                  {menu.title}
                                </LocalizedLink>
                              </li>
                            ))}
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>
                    <div className={s.btnGetInTouchWrapper}>
                      <div
                        className={s.btngetintouch}
                        onClick={() => setModalIsOpen(true)}
                      >
                        <LocalizedLink
                          to={getStaticData(content.boost_your_CX, locale).link}
                        >
                          {getStaticData(content.boost_your_CX, locale).title}
                        </LocalizedLink>
                      </div>
                    </div>
                    {tdcxCN && (
                      <div className={s.headerMobileMenuItemPlain}>
                        <FontAwesomeIcon
                          icon={faPhoneAlt}
                          style={{ marginRight: "5px", color: "#ec5525" }}
                        />{" "}
                        +86 4000890200
                      </div>
                    )}
                  </div>
                </animated.div>
              </div>
            )
          )}
        </>
      </Portal>
    </>
  );
};

export default MobileNav;
